import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { SuiviDTO } from '../model/suivi-dto';
import { SommeTempsDTO } from '../model/somme-temps-dto';
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class SuiviDossierService{
  
    constructor(private http: HttpClient, private _restClientService : RestClientService) 
    {}
    
    getSuivi(requestId) 
    {
        return this._restClientService.load<SuiviDTO[]>('suivi-dossier/suivi/'+requestId);
    }
    
    getSommeTemps(requestId) 
    {
        return this._restClientService.load<SommeTempsDTO>('suivi-dossier/somme-temps/'+requestId);
    }

    getDiagram(requestId: string) 
    {
      const downloadUrl = environment.BACKEND_RACINE_URL+`suivi-dossier/diagram/`+requestId;

      const options = {
        responseType: 'text' as 'json',
      };
      
      return this.http.get<any>(downloadUrl, options);
    }

}      

    